import React, { FC, useState, useEffect } from "react";
import { IFormItem } from "../Types";
import { Badge, Upload, Button, Image, Form, Input, message } from "antd";
import { CloseCircleOutlined } from '@ant-design/icons';
import { importPropsConfig } from "@/utils/importFile";
import { getBaseRequestUrl, getToken, getFileUrl } from "@/utils/constants";

export const __FormFileImage: FC<IFormItem> = ({ md5List = [], onSetFieldsValue, photoNum = 100, ...props }) => {
    const [previewImage, setpreviewImage] = useState<string[]>(md5List); //商品缩略图

    useEffect(() => {
        setpreviewImage(md5List)
    }, [md5List])

    useEffect(() => {
        onSetFieldsValue && onSetFieldsValue({ [props.fieldName]: previewImage })
    }, [previewImage]);

    /*上传图片成功后的回掉 */
    const upLoadCallback = async (file: File & { response: { retData: string } }) => {
        try {
            let md5 = file.response.retData;
            setpreviewImage(origin => [...origin, md5])
        } catch {

        }

    }

    return (
        <>
            <Form.Item name={props.fieldName} hidden><Input /></Form.Item>
            <Form.Item
                label={props.fieldLabel}
                rules={props.rules}
                labelCol={props.labelCol}
            >
                {previewImage && previewImage.map((item, index) => (
                    <div key={index} className="img-file-box">
                        <Badge
                            count={props.disable ? null : <CloseCircleOutlined style={{ color: '#f5222d' }} onClick={(e) => {
                                e.stopPropagation()
                                let originImg = previewImage.filter(imgMd5 => imgMd5 !== item);
                                // console.log(originImg, item)
                                setpreviewImage(originImg);
                            }} />}
                        >
                            {/* <Image src={`${getBaseRequestUrl("TEST")}/fsrv/fetch/${item}?Authorization=${getToken()}`} /> */}
                            <Image src={getFileUrl(item)} />
                        </Badge>
                    </div>
                ))}
                {!props.disable && <Upload
                    showUploadList={false}
                    beforeUpload={(file) => {
                        let fileEnd: string = file.name?.substring(file.name.lastIndexOf(".")) ?? "";
                        let filetypes: string[] = [".jpg", ".png", ".gif", ".svg"];
                        let isType = filetypes?.includes(fileEnd);
                        if (!isType) {
                            message.error('不支持该格式的上传');
                        }
                        const isLt2M = file.size / 1024 / 1024 < 2;
                        if (!isLt2M) {
                            message.error('上传到文件不能超过2M');
                        }
                        return isType && isLt2M;
                    }}

                    {...importPropsConfig(``, upLoadCallback)}
                >
                    {previewImage.length < photoNum && <Button type="link" disabled={props.disable}>上传</Button>}
                </Upload>}
            </Form.Item>
        </>
    )
}
